/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { EditAttachmentNamePayload } from '../models';
// @ts-ignore
import type { GetUploadUrl200Response } from '../models';
/**
 * ConversationMessageAttachmentApi - axios parameter creator
 */
export const ConversationMessageAttachmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary convertBlobIdToFileId
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertBlobIdToFileId: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('convertBlobIdToFileId', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/attachment/convert-blob-id-to-file-id`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete the given attachment.
         * @param {string} conversationId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment: async (conversationId: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('deleteAttachment', 'conversationId', conversationId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('deleteAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/attachment/{attachmentId}`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary editAttachmentName
         * @param {string} conversationId 
         * @param {string} attachmentId 
         * @param {EditAttachmentNamePayload} editAttachmentNamePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAttachmentName: async (conversationId: string, attachmentId: string, editAttachmentNamePayload: EditAttachmentNamePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('editAttachmentName', 'conversationId', conversationId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('editAttachmentName', 'attachmentId', attachmentId)
            // verify required parameter 'editAttachmentNamePayload' is not null or undefined
            assertParamExists('editAttachmentName', 'editAttachmentNamePayload', editAttachmentNamePayload)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/attachment/{attachmentId}`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editAttachmentNamePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAttachmentDownloadUrl
         * @param {string} conversationId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentDownloadUrl: async (conversationId: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getAttachmentDownloadUrl', 'conversationId', conversationId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getAttachmentDownloadUrl', 'attachmentId', attachmentId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/attachment/{attachmentId}/url/download`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getAttachmentThumbnailUrl
         * @param {string} conversationId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentThumbnailUrl: async (conversationId: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getAttachmentThumbnailUrl', 'conversationId', conversationId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getAttachmentThumbnailUrl', 'attachmentId', attachmentId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/attachment/{attachmentId}/url/thumbnail`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{attachmentId}', encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getConversationUploadUrl
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationUploadUrl: async (conversationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getConversationUploadUrl', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/attachment/url/upload`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConversationMessageAttachmentApi - functional programming interface
 */
export const ConversationMessageAttachmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConversationMessageAttachmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary convertBlobIdToFileId
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertBlobIdToFileId(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertBlobIdToFileId(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageAttachmentApi.convertBlobIdToFileId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete the given attachment.
         * @param {string} conversationId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAttachment(conversationId: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAttachment(conversationId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageAttachmentApi.deleteAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary editAttachmentName
         * @param {string} conversationId 
         * @param {string} attachmentId 
         * @param {EditAttachmentNamePayload} editAttachmentNamePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editAttachmentName(conversationId: string, attachmentId: string, editAttachmentNamePayload: EditAttachmentNamePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editAttachmentName(conversationId, attachmentId, editAttachmentNamePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageAttachmentApi.editAttachmentName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getAttachmentDownloadUrl
         * @param {string} conversationId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachmentDownloadUrl(conversationId: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachmentDownloadUrl(conversationId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageAttachmentApi.getAttachmentDownloadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getAttachmentThumbnailUrl
         * @param {string} conversationId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachmentThumbnailUrl(conversationId: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachmentThumbnailUrl(conversationId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageAttachmentApi.getAttachmentThumbnailUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getConversationUploadUrl
         * @param {string} conversationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationUploadUrl(conversationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUploadUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationUploadUrl(conversationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageAttachmentApi.getConversationUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConversationMessageAttachmentApi - factory interface
 */
export const ConversationMessageAttachmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConversationMessageAttachmentApiFp(configuration)
    return {
        /**
         * 
         * @summary convertBlobIdToFileId
         * @param {ConversationMessageAttachmentApiConvertBlobIdToFileIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertBlobIdToFileId(requestParameters: ConversationMessageAttachmentApiConvertBlobIdToFileIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.convertBlobIdToFileId(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete the given attachment.
         * @param {ConversationMessageAttachmentApiDeleteAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAttachment(requestParameters: ConversationMessageAttachmentApiDeleteAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteAttachment(requestParameters.conversationId, requestParameters.attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary editAttachmentName
         * @param {ConversationMessageAttachmentApiEditAttachmentNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAttachmentName(requestParameters: ConversationMessageAttachmentApiEditAttachmentNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.editAttachmentName(requestParameters.conversationId, requestParameters.attachmentId, requestParameters.editAttachmentNamePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAttachmentDownloadUrl
         * @param {ConversationMessageAttachmentApiGetAttachmentDownloadUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentDownloadUrl(requestParameters: ConversationMessageAttachmentApiGetAttachmentDownloadUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUploadUrl200Response> {
            return localVarFp.getAttachmentDownloadUrl(requestParameters.conversationId, requestParameters.attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getAttachmentThumbnailUrl
         * @param {ConversationMessageAttachmentApiGetAttachmentThumbnailUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachmentThumbnailUrl(requestParameters: ConversationMessageAttachmentApiGetAttachmentThumbnailUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUploadUrl200Response> {
            return localVarFp.getAttachmentThumbnailUrl(requestParameters.conversationId, requestParameters.attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getConversationUploadUrl
         * @param {ConversationMessageAttachmentApiGetConversationUploadUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationUploadUrl(requestParameters: ConversationMessageAttachmentApiGetConversationUploadUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUploadUrl200Response> {
            return localVarFp.getConversationUploadUrl(requestParameters.conversationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for convertBlobIdToFileId operation in ConversationMessageAttachmentApi.
 */
export interface ConversationMessageAttachmentApiConvertBlobIdToFileIdRequest {
    readonly conversationId: string
}

/**
 * Request parameters for deleteAttachment operation in ConversationMessageAttachmentApi.
 */
export interface ConversationMessageAttachmentApiDeleteAttachmentRequest {
    readonly conversationId: string

    readonly attachmentId: string
}

/**
 * Request parameters for editAttachmentName operation in ConversationMessageAttachmentApi.
 */
export interface ConversationMessageAttachmentApiEditAttachmentNameRequest {
    readonly conversationId: string

    readonly attachmentId: string

    readonly editAttachmentNamePayload: EditAttachmentNamePayload
}

/**
 * Request parameters for getAttachmentDownloadUrl operation in ConversationMessageAttachmentApi.
 */
export interface ConversationMessageAttachmentApiGetAttachmentDownloadUrlRequest {
    readonly conversationId: string

    readonly attachmentId: string
}

/**
 * Request parameters for getAttachmentThumbnailUrl operation in ConversationMessageAttachmentApi.
 */
export interface ConversationMessageAttachmentApiGetAttachmentThumbnailUrlRequest {
    readonly conversationId: string

    readonly attachmentId: string
}

/**
 * Request parameters for getConversationUploadUrl operation in ConversationMessageAttachmentApi.
 */
export interface ConversationMessageAttachmentApiGetConversationUploadUrlRequest {
    readonly conversationId: string
}

/**
 * ConversationMessageAttachmentApi - object-oriented interface
 */
export class ConversationMessageAttachmentApi extends BaseAPI {
    /**
     * 
     * @summary convertBlobIdToFileId
     * @param {ConversationMessageAttachmentApiConvertBlobIdToFileIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public convertBlobIdToFileId(requestParameters: ConversationMessageAttachmentApiConvertBlobIdToFileIdRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageAttachmentApiFp(this.configuration).convertBlobIdToFileId(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete the given attachment.
     * @param {ConversationMessageAttachmentApiDeleteAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAttachment(requestParameters: ConversationMessageAttachmentApiDeleteAttachmentRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageAttachmentApiFp(this.configuration).deleteAttachment(requestParameters.conversationId, requestParameters.attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary editAttachmentName
     * @param {ConversationMessageAttachmentApiEditAttachmentNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public editAttachmentName(requestParameters: ConversationMessageAttachmentApiEditAttachmentNameRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageAttachmentApiFp(this.configuration).editAttachmentName(requestParameters.conversationId, requestParameters.attachmentId, requestParameters.editAttachmentNamePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAttachmentDownloadUrl
     * @param {ConversationMessageAttachmentApiGetAttachmentDownloadUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAttachmentDownloadUrl(requestParameters: ConversationMessageAttachmentApiGetAttachmentDownloadUrlRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageAttachmentApiFp(this.configuration).getAttachmentDownloadUrl(requestParameters.conversationId, requestParameters.attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getAttachmentThumbnailUrl
     * @param {ConversationMessageAttachmentApiGetAttachmentThumbnailUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAttachmentThumbnailUrl(requestParameters: ConversationMessageAttachmentApiGetAttachmentThumbnailUrlRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageAttachmentApiFp(this.configuration).getAttachmentThumbnailUrl(requestParameters.conversationId, requestParameters.attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getConversationUploadUrl
     * @param {ConversationMessageAttachmentApiGetConversationUploadUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConversationUploadUrl(requestParameters: ConversationMessageAttachmentApiGetConversationUploadUrlRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageAttachmentApiFp(this.configuration).getConversationUploadUrl(requestParameters.conversationId, options).then((request) => request(this.axios, this.basePath));
    }
}

